import { render, staticRenderFns } from "./CMessage.vue?vue&type=template&id=20f42ffc&scoped=true&"
import script from "./CMessage.vue?vue&type=script&lang=js&"
export * from "./CMessage.vue?vue&type=script&lang=js&"
import style0 from "./CMessage.vue?vue&type=style&index=0&id=20f42ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f42ffc",
  null
  
)

export default component.exports